module.exports = __webpack_public_path__ + "img/Girl_020026.f5b40d95.png";